/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Refineexampleremovebackground3Inputs */

const en_refineexampleremovebackground3 = /** @type {(inputs: Refineexampleremovebackground3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Remove background`)
};

const de_refineexampleremovebackground3 = /** @type {(inputs: Refineexampleremovebackground3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hintergrund entfernen`)
};

/**
* | output |
* | --- |
* | "Remove background" |
*
* @param {Refineexampleremovebackground3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const refineexampleremovebackground3 = /** @type {((inputs?: Refineexampleremovebackground3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Refineexampleremovebackground3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_refineexampleremovebackground3(inputs)
	return de_refineexampleremovebackground3(inputs)
});
export { refineexampleremovebackground3 as "refineExampleRemoveBackground" }